module.exports = __webpack_public_path__ + "img/05.a09cc4e7.png";